module.exports = "https://cdn.dove.it/_next/static/public/assets/hero/wizard/hero.041ee5886754497ccf23a1fe5f31c61f.jpg";